module.exports = __webpack_public_path__ + "img/img1.bec4c4fe.jpg";